/*
 * @auth: jason
 */
import Vue from 'vue'
import moment from 'moment'

Vue.directive('dateFormat', {
  inserted: function (el, binding, vnode) {
    const { value: _obj } = binding;const { context: _this, data } = vnode;const { expression: key } = data.model;let arr = []
    const setModelValue = function(value,len) {
      // check length zz match
      if(value.indexOf("mt") != -1) {
        var values = value.split('mt')
        values[0]=values[0].trim();values[1]=values[1].trim();
        var day1 = new Date();
        day1.setDate(day1.getDate() + 1);
        if(values[1] && !isNaN(Number(values[1]))) {
          if(values[1].length==1)values[1]='0'+values[1]+'00';if(values[1].length==2){if(!isNaN(Number(values[1]))){values[1]=parseInt(values[1])>24?'24':values[1];}values[1]=values[1]+'00';}if(values[1].length==3)values[1]='0'+values[1];
          value=day1.format("yyyyMMdd")+values[1]
        } else {
          value=day1.format("yyyyMMdd")
        }
      }else if(value.indexOf("ht") != -1) {
        var values = value.split('ht')
        values[0]=values[0].trim();values[1]=values[1].trim();
        var day1 = new Date();
        day1.setDate(day1.getDate() + 2);
        if(values[1] && !isNaN(Number(values[1]))) {
          if(values[1].length==1)values[1]='0'+values[1]+'00';if(values[1].length==2){if(!isNaN(Number(values[1]))){values[1]=parseInt(values[1])>24?'24':values[1];}values[1]=values[1]+'00';}if(values[1].length==3)values[1]='0'+values[1];
          value=day1.format("yyyyMMdd")+values[1]
        }else {
          value=day1.format("yyyyMMdd")
        }
      }else if(value.indexOf("t") != -1) {
        var values = value.split('t')
        values[0]=values[0].trim();values[1]=values[1].trim();
        if (values[0] && !isNaN(Number(values[0]))) {
          if(values[0].length==1)values[0]=new Date().format('yyyyMM')+'0'+values[0];
          if(values[0].length==2)values[0]=new Date().format('yyyyMM')+values[0];
          if(values[0].length==3)values[0]=new Date().format('yyyy')+'0'+values[0];
          if(values[0].length==4)values[0]=new Date().format('yyyy')+values[0];
          if(values[1].length==1)values[1]='0'+values[1]+'00';if(values[1].length==2){if(!isNaN(Number(values[1]))){values[1]=parseInt(values[1])>24?'24':values[1];}values[1]=values[1]+'00';}if(values[1].length==3)values[1]='0'+values[1];
          value=values[0]+values[1]
        } else if(values[1] && !isNaN(Number(values[1]))) {
          if(values[1].length==1)values[1]='0'+values[1]+'00';if(values[1].length==2){if(!isNaN(Number(values[1]))){values[1]=parseInt(values[1])>24?'24':values[1];}values[1]=values[1]+'00';}if(values[1].length==3)values[1]='0'+values[1];
          value=new Date().format('yyyyMMdd')+values[1]
        }
      }
      if(value.length==1)value=new Date().format('yyyyMM')+'0'+value;
      if(value.length==2){if(!isNaN(Number(value))){value=parseInt(value)>getLastDay()?getLastDay():value;}value=new Date().format('yyyyMM')+value;}
      if(value.length==3)value=new Date().format('yyyy')+'0'+value;
      if(value.length==4)value=new Date().format('yyyy')+value;
      if(value.length==9)value=value+'0';
      if(value.length==11)value=value.slice(0,8)+'0'+value.slice(8);
      if(value.length>5&&value.length<9) {
        value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3')
      }else if(value.length>9&&value.length<13){
        value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3 $4:$5')
      }else if(value.length>12){
        value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3 $4:$5:$6')
      }else{return false}
      const time = value && value.constructor == String ? moment(value) : value
      let keys = key.split('.');if(arr.length === len) {arr = [];}if (time._d=='Invalid Date')return false;var timeOne=moment(time._i, time._f)._d;arr.push(timeOne)
      // set value
      if(!_obj) {
        // handle
        if (keys && keys.length >= 2) {
          const [key1, key2, key3, key4] = keys
          if (key4) { _this[key1][key2][key3][key4] = len===2?arr:timeOne;} else if (key3) {
            // _this[key1][key2][key3] = len===2?arr:timeOne;
          } else {_this[key1][key2] = len===2?arr:timeOne;}
        }else{_this[key] = len===2?arr:timeOne;}
      }else{
        // handle for value
        let objKey =  _obj.obj.split('.')
        if (objKey && objKey.length >= 2) {
          const [flag1, flag2, flag3, flag4] = objKey;
          if (flag4) {_this[flag1][flag2][flag3][flag4][_obj.index][_obj.modelName] = len===2?arr:time;} else if (flag3) {_this[flag1][flag2][flag3][_obj.index][_obj.modelName] = len===2?arr:time;
          } else {_this[flag1][flag2][_obj.index][_obj.modelName] = len===2?arr:time;}
        }else{_this[objKey][_obj.modelName] = len===2?arr:time;}
      }
    };
    if(_this && _this._isVue) {
      const $this = el.children[0]
      // getinput-add-change-event
      if(el.children[0]) {
        $this.addEventListener('change', function() {let value = $this.value;setModelValue(value,1);})
      }else{
        $this.addEventListener('change', function() {let value = $this.val();setModelValue(value,1);})
      }
    }
  }
})

Vue.directive('dateFormatT', {
  inserted: function (el, binding, vnode) {
    const { value: _obj } = binding;const { context: _this, data } = vnode;const { expression: key } = data.model;let arr = []
    const setModelValue = function(value,len) {
      // check length zz match
      if(value.indexOf("mt") != -1) {
        var values = value.split('mt')
        values[0]=values[0].trim();values[1]=values[1].trim();
        var day1 = new Date();
        day1.setDate(day1.getDate() + 1);
        if(values[1] && !isNaN(Number(values[1]))) {
          if(values[1].length==1)values[1]='0'+values[1]+'00';if(values[1].length==2){if(!isNaN(Number(values[1]))){values[1]=parseInt(values[1])>24?'24':values[1];}values[1]=values[1]+'00';}if(values[1].length==3)values[1]='0'+values[1];
          value=day1.format("yyyyMMdd")+values[1]
        } else {
          value=day1.format("yyyyMMdd")
        }
      }else if(value.indexOf("ht") != -1) {
        var values = value.split('ht')
        values[0]=values[0].trim();values[1]=values[1].trim();
        var day1 = new Date();
        day1.setDate(day1.getDate() + 2);
        if(values[1] && !isNaN(Number(values[1]))) {
          if(values[1].length==1)values[1]='0'+values[1]+'00';if(values[1].length==2){if(!isNaN(Number(values[1]))){values[1]=parseInt(values[1])>24?'24':values[1];}values[1]=values[1]+'00';}if(values[1].length==3)values[1]='0'+values[1];
          value=day1.format("yyyyMMdd")+values[1]
        }else {
          value=day1.format("yyyyMMdd")
        }
      }else if(value.indexOf("t") != -1) {
        var values = value.split('t')
        values[0]=values[0].trim();values[1]=values[1].trim();
        if (values[0] && !isNaN(Number(values[0]))) {
          if(values[0].length==1)values[0]=new Date().format('yyyyMM')+'0'+values[0];
          // if(values[0].length==2)values[0]=new Date().format('yyyyMM')+values[0];
          if(values[0].length==2){if(!isNaN(Number(values[0]))){values[0]=parseInt(values[0])>getLastDay()?getLastDay():values[0];}values[0]=new Date().format('yyyyMM')+values[0];}
          if(values[0].length==3)values[0]=new Date().format('yyyy')+'0'+values[0];
          if(values[0].length==4)values[0]=new Date().format('yyyy')+values[0];
          if(values[1].length==1)values[1]='0'+values[1]+'00';if(values[1].length==2){if(!isNaN(Number(values[1]))){values[1]=parseInt(values[1])>24?'24':values[1];}values[1]=values[1]+'00';}if(values[1].length==3)values[1]='0'+values[1];
          value=values[0]+values[1]
        } else if(values[1] && !isNaN(Number(values[1]))) {
          if(values[1].length==1)values[1]='0'+values[1]+'00';if(values[1].length==2){if(!isNaN(Number(values[1]))){values[1]=parseInt(values[1])>24?'24':values[1];}values[1]=values[1]+'00';}if(values[1].length==3)values[1]='0'+values[1];
          value=new Date().format('yyyyMMdd')+values[1]
        }
      }
      if(value.length==1)value=new Date().format('yyyyMM')+'0'+value;
      if(value.length==2){if(!isNaN(Number(value))){value=parseInt(value)>getLastDay()?getLastDay():value;}value=new Date().format('yyyyMM')+value;}
      if(value.length==3)value=new Date().format('yyyy')+'0'+value;
      if(value.length==4)value=new Date().format('yyyy')+value;
      if(value.length==9)value=value+'0';
      if(value.length==11)value=value.slice(0,8)+'0'+value.slice(8);
      if(value.length>5&&value.length<9) {
        value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3')
      }else if(value.length>9&&value.length<13){
        value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3 $4:$5')
      }else if(value.length>12){
        value = value.replace(/^(\d{4})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*(\d{1,2})\D*/, '$1-$2-$3 $4:$5:$6')
      }else{return false}
      const time = value && value.constructor == String ? moment(value) : value
      let keys = key.split('.');if(arr.length === len) {arr = [];}if (time._d=='Invalid Date')return false;var timeOne=moment(time._i, time._f)._d;arr.push(timeOne)
      // set value
      if(!_obj) {
        // handle
        if (keys && keys.length >= 2) {
          const [key1, key2, key3, key4] = keys
          if (key4) { _this[key1][key2][key3][key4] = len===2?arr:timeOne.getTime();} else if (key3) {
            // _this[key1][key2][key3] = len===2?arr:timeOne;
          } else {_this[key1][key2] = len===2?arr:timeOne.getTime();}
        }else{_this[key] = len===2?arr:timeOne.getTime();}
      }else{
        // handle for value
        let objKey =  _obj.obj.split('.')
        if (objKey && objKey.length >= 2) {
          const [flag1, flag2, flag3, flag4] = objKey;
          if (flag4) {_this[flag1][flag2][flag3][flag4][_obj.index][_obj.modelName] = len===2?arr:time;} else if (flag3) {_this[flag1][flag2][flag3][_obj.index][_obj.modelName] = len===2?arr:time;
          } else {_this[flag1][flag2][_obj.index][_obj.modelName] = len===2?arr:time;}
        }else{_this[objKey][_obj.modelName] = len===2?arr:time;}
      }
    };
    if(_this && _this._isVue) {
      const $this = el.children[0]
      // getinput-add-change-event
      if(el.children[0]) {
        $this.addEventListener('change', function() {let value = $this.value;setModelValue(value,1);})
      }else{
        $this.addEventListener('change', function() {let value = $this.val();setModelValue(value,1);})
      }
    }
  }
})

Vue.directive('timeFormat', {
  inserted: function (el, binding, vnode) {
    const { value: _obj } = binding;const { context: _this, data } = vnode;const { expression: key } = data.model;let arr = []
    const setModelValue = function(value,len) {
      // check length zz match
      if(value.length>0) {
        if(value.length==1)value='0'+value+'00';if(value.length==2){if(!isNaN(Number(value))){value=parseInt(value)>24?'24':value;}value=value+'00';}if(value.length==3)value='0'+value;value = value.replace(/^(\d{1,2})\D*(\d{1,2})\D*/, '$1:$2')
      }else{return false}
      value=new Date().format('yyyy-MM-dd') + ' ' + value
      const time = value && value.constructor == String ? moment(value) : value
      let keys = key.split('.');if(arr.length === len) {arr = [];}if (time._d=='Invalid Date')return false;var timeOne=moment(time._i, time._f)._d;arr.push(timeOne)
      // set value
      if(!_obj) {
        // handle
        if (keys && keys.length >= 2) {
          const [key1, key2, key3, key4] = keys
          if (key4) { _this[key1][key2][key3][key4] = len===2?arr:timeOne;} else if (key3) {_this[key1][key2][key3] = len===2?arr:timeOne;} else {_this[key1][key2] = len===2?arr:timeOne;}
        }else{_this[key] = len===2?arr:timeOne;}
      }else{
        // handle for value
        let objKey =  _obj.obj.split('.')
        if (objKey && objKey.length >= 2) {
          const [flag1, flag2, flag3, flag4] = objKey;
          if (flag4) {_this[flag1][flag2][flag3][flag4][_obj.index][_obj.modelName] = len===2?arr:time;} else if (flag3) {_this[flag1][flag2][flag3][_obj.index][_obj.modelName] = len===2?arr:time;
          } else {_this[flag1][flag2][_obj.index][_obj.modelName] = len===2?arr:time;}
        }else{_this[objKey][_obj.modelName] = len===2?arr:time;}
      }
    };
    if(_this && _this._isVue) {
      const $this = el.children[0]
      // getinput-add-change-event
      if(el.children[0]) {
        $this.addEventListener('change', function() {let value = $this.value;setModelValue(value,1);})
      }else{
        $this.addEventListener('change', function() {let value = $this.val();setModelValue(value,1);})
      }
    }
  }
})

Vue.directive('timeSelect', {
  inserted: function (el, binding, vnode) {
    const { value: _obj } = binding;const { context: _this, data } = vnode;const { expression: key } = data.model;let arr = []
    const setModelValue = function(value,len) {
      // check length zz match
      if(value.length>0) {
        if(value.length==1)value='0'+value+'00';if(value.length==2){if(!isNaN(Number(value))){value=parseInt(value)>24?'24':value;}value=value+'00';}if(value.length==3)value='0'+value;value = value.replace(/^(\d{1,2})\D*(\d{1,2})\D*/, '$1:$2')
      }else{return false}
      const time = value
      let keys = key.split('.');if(arr.length === len) {arr = [];}
      // set value
      if(!_obj) {
        // handle
        if (keys && keys.length >= 2) {
          const [key1, key2, key3, key4] = keys
          if (key4) { _this[key1][key2][key3][key4] = len===2?arr:time;} else if (key3) {_this[key1][key2][key3] = len===2?arr:time;} else {_this[key1][key2] = len===2?arr:time;}
        }else{_this[key] = len===2?arr:time;}
      }else{
        // handle for value
        let objKey =  _obj.obj.split('.')
        if (objKey && objKey.length >= 2) {
          const [flag1, flag2, flag3, flag4] = objKey;
          if (flag4) {_this[flag1][flag2][flag3][flag4][_obj.index][_obj.modelName] = len===2?arr:time;} else if (flag3) {_this[flag1][flag2][flag3][_obj.index][_obj.modelName] = len===2?arr:time;
          } else {_this[flag1][flag2][_obj.index][_obj.modelName] = len===2?arr:time;}
        }else{_this[objKey][_obj.modelName] = len===2?arr:time;}
      }
    };
    if(_this && _this._isVue) {
      const $this = el.children[0]
      // getinput-add-change-event
      if(el.children[0]) {
        $this.addEventListener('change', function() {let value = $this.value;setModelValue(value,1);})
      }else{
        $this.addEventListener('change', function() {let value = $this.val();setModelValue(value,1);})
      }
    }
  }
})
function getLastDay(){
  var month = new Date().getMonth();
  var new_year = new Date().getYear();
  var new_month = month+1;
  if(month>12){
    new_month -=12;
    new_year++;
  }
  var new_date = new Date(new_year,new_month,1);
  return (new Date(new_date.getTime()-1000*60*60*24)).getDate();
}
function $(id) {return document.getElementById(id);}
export default Vue



// WEBPACK FOOTER //
// ./src/components/timeDate/timeDate.js